import { Link } from 'react-router-dom';

import { LostArt } from '@/components/illustrations';
import { Button, Card, CardContent } from '@/components/cargofl-ui';
import { PageContainer } from '@/components/shell/page-container';

export function NotFoundPage() {
  return (
    <PageContainer>
      <Card>
        <CardContent className="space-y-4 py-12 text-center sm:py-12">
          <LostArt className="mx-auto h-28 w-auto" />
          <h2 className="text-lg font-semibold">That page does not exist</h2>
          <p className="text-sm text-muted-foreground">
            The link may be out of date, or the record it pointed at may have been archived.
          </p>
          <Button asChild>
            <Link to="/">Back to the start</Link>
          </Button>
        </CardContent>
      </Card>
    </PageContainer>
  );
}
